// src/pages/DoctorsOverview/DoctorsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchClinicsList,
  fetchDoctorsList,
  createOrUpdateClinic,
  createOrUpdateDoctor,
  removeClinic,
  removeDoctor,
  fetchLocations,
  fetchClinicsDetails,
} from "./DoctorsThunk";

const initialState = {
  clinicsList: [],
  clinicsDetails: [],
  doctorsList: [],
  locations: [],

  // modal state
  isClinicModalOpen: false,
  isDoctorModalOpen: false,
  isEditClinic: false,
  isEditDoctor: false,
  selectedClinic: null,
  selectedDoctor: null,

  loading: false,
  error: null,
};

const doctorsSlice = createSlice({
  name: "doctors",
  initialState,
  reducers: {
    openClinicModal: (state, action) => {
      state.isClinicModalOpen = true;
      state.selectedClinic = action.payload || null;
      state.isEditClinic = !!action.payload;
    },
    closeClinicModal: (state) => {
      state.isClinicModalOpen = false;
      state.selectedClinic = null;
      state.isEditClinic = false;
    },
    openDoctorModal: (state, action) => {
      state.isDoctorModalOpen = true;
      state.selectedDoctor = action.payload || null;
      state.isEditDoctor = !!action.payload;
    },
    closeDoctorModal: (state) => {
      state.isDoctorModalOpen = false;
      state.selectedDoctor = null;
      state.isEditDoctor = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // clinics list
      .addCase(fetchClinicsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchClinicsList.fulfilled, (state, action) => {
        state.loading = false;
        state.clinicsList = action.payload.data || action.payload || [];
      })
      .addCase(fetchClinicsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // clinics details
      .addCase(fetchClinicsDetails.fulfilled, (state, action) => {
        state.clinicsDetails = action.payload.data || action.payload || [];
      })

      // doctors list
      .addCase(fetchDoctorsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDoctorsList.fulfilled, (state, action) => {
        state.loading = false;
        state.doctorsList = action.payload.data || action.payload || [];
      })
      .addCase(fetchDoctorsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create/update clinic
      .addCase(createOrUpdateClinic.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrUpdateClinic.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createOrUpdateClinic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create/update doctor
      .addCase(createOrUpdateDoctor.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrUpdateDoctor.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createOrUpdateDoctor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // delete clinic
      .addCase(removeClinic.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeClinic.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(removeClinic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // delete doctor
      .addCase(removeDoctor.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeDoctor.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(removeDoctor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // locations
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.locations = action.payload || [];
      });
  },
});

export const {
  openClinicModal,
  closeClinicModal,
  openDoctorModal,
  closeDoctorModal,
} = doctorsSlice.actions;

export default doctorsSlice.reducer;
